<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-body>
                        <h5 class="heading-1 mb-4">
                            <span>ANEXOS</span>
                            <div class="float-right">
                                <span class="text-primary">
                                    <i
                                        class="fa fa-refresh fa-lg icon-button"
                                        title="Atualizar"
                                        @click.stop="obterAnexos()"
                                    ></i>
                                </span>
                            </div>
                        </h5>
                        <app-tabela
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="success"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        >Inserir Anexo</b-button
                                    >
                                    <b-button
                                        class="ml-2"
                                        variant="warning"
                                        @click.stop="$emit('fechar')"
                                        ><i class="fa fa-times-circle"></i>
                                        Fechar Anexos</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <projeto-anexo-download
                                    v-if="$temAcessoView('SGTEC-PROJ-ANX-03')"
                                    :anexo="data"
                                    :servicos="obterServicos()"
                                ></projeto-anexo-download>
                                <projeto-anexo-excluir
                                    v-if="$temAcessoView('SGTEC-PROJ-ANX-02')"
                                    :anexo="data"
                                    :servicos="obterServicos()"
                                    @obterAnexosAtualizados="obterAnexos()"
                                ></projeto-anexo-excluir>
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <projeto-anexo-form
            ref="projetoAnexoForm"
            @obterAnexosAtualizados="obterAnexos()"
            :projeto="projeto"
            :servicos="obterServicos()"
        ></projeto-anexo-form>
    </div>
</template>

<script>
import ProjetoAnexoDownload from './ProjetoAnexoDownload'
import ProjetoAnexoForm from './ProjetoAnexoForm'
import ProjetoAnexoExcluir from './ProjetoAnexosExcluir'
import ProjetosAnexosServicos from './ProjetosAnexosServicos'

export default {
    props: {
        projeto: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            anexos: [],
            campos: [
                {
                    key: 'tipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        obterServicos() {
            return ProjetosAnexosServicos
        },

        obterAnexos() {
            this.$store.dispatch('addRequest')
            ProjetosAnexosServicos.obterAnexos(
                this.projeto.projetoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.anexos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirAnexo() {
            this.$refs.projetoAnexoForm.mostrarModal = true
        }
    },

    created() {
        this.obterAnexos()
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return this.$temAcesso('SGTEC-PROJ-ANX-01')
        }
    },

    components: {
        ProjetoAnexoForm,
        ProjetoAnexoDownload,
        ProjetoAnexoExcluir
    }
}
</script>
